module.exports = __webpack_public_path__ + "media/images/icons/star-1-blue-35074ce2ba22dee6f056ae169c1e9228.svg";